import { render, staticRenderFns } from "./assignTemplate.vue?vue&type=template&id=d5239820&scoped=true&"
import script from "./assignTemplate.vue?vue&type=script&lang=js&"
export * from "./assignTemplate.vue?vue&type=script&lang=js&"
import style0 from "./assignTemplate.vue?vue&type=style&index=0&id=d5239820&prod&scoped=true&lang=css&"
import style1 from "./assignTemplate.vue?vue&type=style&index=1&id=d5239820&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5239820",
  null
  
)

export default component.exports